import { Icon, Grid } from '../../../../base';
import { SourceOfHireViewType } from '../../../../common';
import { StyledToggleButton } from './SourceOfHireViewToggle.styles';

interface ISourceOfHireViewToggleProps {
    activeView: SourceOfHireViewType;
    onChange: (view: SourceOfHireViewType) => void;
}

const TOGGLE_ITEMS: { type: SourceOfHireViewType; icon: string }[] = [
    { type: SourceOfHireViewType.TABLE, icon: 'TableRowsOutlinedIcon' },
    { type: SourceOfHireViewType.PIE, icon: 'PieChartOutlinedIcon' },
    { type: SourceOfHireViewType.BAR, icon: 'BarChartOutlinedIcon' },
];

const SourceOfHireViewToggle = ({
    activeView,
    onChange,
}: ISourceOfHireViewToggleProps) => {
    return (
        <Grid container>
            {TOGGLE_ITEMS.map((item) => (
                <span key={item.type}>
                    <StyledToggleButton
                        isActive={activeView === item.type}
                        onClick={() => onChange(item.type)}
                        size="small"
                    >
                        <Icon name={item.icon} size={23} />
                    </StyledToggleButton>
                </span>
            ))}
        </Grid>
    );
};

export default SourceOfHireViewToggle;
